/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseMutationModel,
  IMutationModelOpts,
  useGqlClient,
} from '@r-client/shared/data/client';
import { useLocalObservable } from 'mobx-react-lite';
import {
  IUpdateOnboardingFlowStateMutation,
  UpdateOnboardingFlowStateDocument,
  IUpdateOnboardingFlowStateMutationVariables,
} from './types';
import { IUserOnboardingFlowStateUpdatePayload } from '@r-client/data/graphql-types';
export type { IUserOnboardingFlowStateUpdatePayload };

export class UpdateOnboardingFlowStateMutation extends BaseMutationModel<
  IUpdateOnboardingFlowStateMutation,
  IUpdateOnboardingFlowStateMutationVariables
> {
  get mutation() {
    return UpdateOnboardingFlowStateDocument;
  }
}
export function useUpdateOnboardingFlowStateMutation(
  opts?: Omit<
    IMutationModelOpts<IUpdateOnboardingFlowStateMutationVariables>,
    'client'
  >
) {
  const client = useGqlClient();
  return useLocalObservable(
    () => new UpdateOnboardingFlowStateMutation({ ...opts, client })
  );
}
